import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Button, Icon, Link, Picture, Table, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import mixpanel from "mixpanel-browser";
import moment from "moment";
import { RoutesEnum } from "~/types/enums";
import lists from "~/lib/lists";
import Markdown from "~/components/Markdown";
import { useTranslation } from "react-i18next";
import Collapsable from "~/components/Collapsable";
import Dropdown from "../../../components-shared/Dropdown";
const StyledButton = styled(Button)`
  & span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const NotMovingTableRow = _ref => {
  let {
    item,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const dayDiff = moment().diff(moment(item.date), "days");
  const handleDismiss = () => {
    mixpanel.track(`Insights Not Moving – Dismiss`, {
      lineItemId: item.id
    });
  };
  const handleMarkDone = () => {
    mixpanel.track(`Insights Not Moving – Close`, {
      lineItemId: item.id
    });
  };
  const handleTopicClick = topicId => {
    const url = `${window.location.origin}${RoutesEnum.TOPIC.replace(":topicId", topicId)}?view=footprints`;
    window.open(url, "_blank");
  };
  return /*#__PURE__*/React.createElement(Table.Tr, _extends({
    key: item.id
  }, rest), /*#__PURE__*/React.createElement(Table.Td, null), /*#__PURE__*/React.createElement(Table.Td, null, item.topics.length ? item.topics.map(topic => /*#__PURE__*/React.createElement(StyledButton, {
    key: topic.id,
    onClick: () => handleTopicClick(topic.id),
    fontSize: 3,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": topic.name,
    s: {
      px: 2,
      py: 1
    },
    maxWidth: "200px",
    color: "translucentPrimary"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "timelapse",
    s: {
      mr: 1,
      mt: -0.5
    }
  }), topic.name)) : /*#__PURE__*/React.createElement(Text, {
    color: "text",
    weight: "semiBold"
  }, "No Linked Topics")), /*#__PURE__*/React.createElement(Table.Td, null, /*#__PURE__*/React.createElement(Link, {
    href: item.url,
    color: "textSecondary",
    weight: "semiBold",
    display: "block",
    underline: true
  }, lists.topics.footprintTypes.names[item.type])), /*#__PURE__*/React.createElement(Table.Td, null, /*#__PURE__*/React.createElement(Collapsable, {
    maxHeight: 100
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: item.name,
    linkColor: "primary"
  }))), /*#__PURE__*/React.createElement(Table.Td, null, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    weight: "semiBold"
  }, dayDiff === 0 ? "Today" : dayDiff === 1 ? "Yesterday" : `${dayDiff} days`)), /*#__PURE__*/React.createElement(Table.Td, null, /*#__PURE__*/React.createElement(Link, {
    href: `${window.location.origin}${RoutesEnum.MEMBER.replace(":memberId", item.member.id)}`,
    color: "textSecondary",
    underline: true
  }, item.member.firstName, " ", item.member.lastName)), /*#__PURE__*/React.createElement(Table.Td, {
    center: true
  }, /*#__PURE__*/React.createElement(Picture, {
    width: "1.5rem",
    height: "1.5rem",
    display: "inline-block",
    border: "squared",
    s: {
      mb: -0.5
    },
    src: lists.common.apps.logos(theme)[item.source]
  })), /*#__PURE__*/React.createElement(Table.Td, null, /*#__PURE__*/React.createElement(Dropdown, {
    direction: "bottomLeft",
    handlerProps: {
      s: {
        p: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.options")
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      src: "dots-vertical",
      color: theme.colors.text.primary,
      display: "block"
    })
  }, _ref2 => {
    let {
      isOpen,
      onItemClick
    } = _ref2;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: e => {
        e.stopPropagation();
        handleDismiss();
        onItemClick();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "cross",
      scale: 4.5,
      s: {
        mr: 2
      },
      color: "primary"
    }), t("common.actions.dismiss"), /*#__PURE__*/React.createElement(Icon, {
      s: {
        ml: 1
      },
      color: "primary",
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-html": "<strong>Hide</strong> Item from your report",
      src: "infoOutline",
      style: {
        cursor: "help"
      }
    })), /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: e => {
        e.stopPropagation();
        handleMarkDone();
        onItemClick();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "tick",
      scale: 4.5,
      s: {
        mr: 2
      },
      color: "primary"
    }), t("FindingTableRow.markDone")));
  })), /*#__PURE__*/React.createElement(Table.Td, null));
};
export default NotMovingTableRow;